import { NavTabsV2 } from '@cimplico/components';
import { useIsFirmRole } from '../../hooks/use-is-firm-role';
import { useFirmContext } from '../../providers/FirmProvider';
import { NavLink } from 'react-router-dom';
import CimplicoStaffGuard from '../cimplico-staff-guard/CimplicoStaffGuard';

const styles = {
    tab: {
        default: {
            unselected:
                'border-transparent rounded-md text-gray-500 hover:bg-indigo-50 whitespace-nowrap border-b-2 w-full font-medium text-sm cursor-pointer group inline-flex items-center cursor:pointer px-5 py-2 dark:hover:bg-indigo-900 dark:text-gray-400 outline-none',
            selected: 'bg-indigo-50 dark:bg-indigo-900 text-indigo-600 dark:text-indigo-100',
            disabled: 'opacity-75 cursor-not-allowed border-none dark:border-none hover:bg-transparent',
        },
    },
};

function FirmNavbar(): JSX.Element {
    const { isExternalUser } = useIsFirmRole();
    const { shortId } = useFirmContext();

    return (
        <div data-intercom-target="header-navigation-tabs" className="h-12 flex items-center z-50 w-full">
            <NavTabsV2 pill colorMode="dark" name="top-nav">
                <NavTabsV2.Tab label="Home" link={`/${shortId}/dashboard`} />
                <NavTabsV2.Tab label="Groups" link={`/${shortId}/groups`} />
                <NavTabsV2.Tab label="Entities" link={`/${shortId}/entities`} />
                <NavTabsV2.Tab label="Workpapers" link={`/${shortId}/workpapers`} />
                {!isExternalUser && (
                    <NavTabsV2.Tab label="Templates" link={`/${shortId}/templates`}>
                        {({ close }): JSX.Element => (
                            <div className="flex flex-col gap-1">
                                <NavLink
                                    className={({ isActive }): string =>
                                        `${styles.tab.default.unselected} ${isActive ? styles.tab.default.selected : ''} outline-none`
                                    }
                                    onClick={close}
                                    to={`/${shortId}/templates/procedures`}
                                >
                                    Procedures
                                </NavLink>

                                <NavLink
                                    className={({ isActive }): string =>
                                        `${styles.tab.default.unselected} ${isActive ? styles.tab.default.selected : ''} outline-none`
                                    }
                                    onClick={close}
                                    to={`/${shortId}/templates/checklists`}
                                >
                                    Checklists
                                </NavLink>
                                <CimplicoStaffGuard>
                                    <NavLink
                                        className={({ isActive }): string =>
                                            `${styles.tab.default.unselected} ${isActive ? styles.tab.default.selected : ''} outline-none`
                                        }
                                        onClick={close}
                                        to={`/${shortId}/templates/calculations`}
                                    >
                                        Calculations
                                    </NavLink>
                                </CimplicoStaffGuard>
                            </div>
                        )}
                    </NavTabsV2.Tab>
                )}
            </NavTabsV2>
        </div>
    );
}

export default FirmNavbar;
